"use strict";

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function () {
    document.addEventListener("click", function (e) {
      console.log("clicked");

      if (e.target.closest(".variant_quote_submit")) {
        let hasQty = false;
        const qtyInputs = document.querySelectorAll(".cws-number-only");

        qtyInputs.forEach((input) => {
          let val = parseFloat(input.value) || 0;
          if (val > 0) hasQty = true;
        });

       if (!hasQty) {
         e.preventDefault();

         // Show error message
         const msgEl = document.querySelector("#qmp_pop_msg");
         if (msgEl) {
           msgEl.textContent =
             "You must enter a quantity for at least one item before continuing!";

           // Trigger shake animation
           msgEl.classList.remove("msg-shake"); // reset animation
           void msgEl.offsetWidth; // force reflow to restart animation
           msgEl.classList.add("msg-shake");
         }
         // Add red border to the parent .qty-box
         qtyInputs.forEach((input) => {
           const parent = input.closest(".qty-box");
        //    if (parent) parent.style.border = "1px solid red";
         });

         return false;
       } else {
         // Clear borders when valid
         qtyInputs.forEach((input) => {
           const parent = input.closest(".qty-box");
           if (parent) parent.style.border = "";
         });
       }

      }
    });
  }, 3000); // initial delay after DOM load
});


// fix issue with required checkbox on contact form
document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('ContactForm');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    let valid = true;

    // Find all required checkbox groups
    const requiredGroups = form.querySelectorAll('.field_checkbox[data-required="true"]');

    requiredGroups.forEach(group => {
      const checkboxes = group.querySelectorAll('input[type="checkbox"]');
      const oneChecked = Array.from(checkboxes).some(cb => cb.checked);

      if (!oneChecked) {
        valid = false;
        group.classList.add('field_checkbox--error');
      } else {
        group.classList.remove('field_checkbox--error');
      }
    });

    // If validation failed, stop the form completely
    if (!valid) {
      e.preventDefault();
      e.stopImmediatePropagation();  // ← prevents Shopify script from submitting
      form.classList.add('form-error');

      // Scroll to first invalid group
      const firstError = form.querySelector('.field_checkbox--error');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return false; // hard stop
    }
  });
});
